(() => {
  const wishlistButtonSelector = ".iWishAddColl";
  const wishlistCounterSelector = ".iwish-counter";
  const wishlistPageLinkSelector = ".wishlist-page-link";
  let wishlistIcon;
  let wishlistIconMarkup;
  let refreshTimer;

  function isIWishReady() {
    return typeof window.iWish?.checkIwishColl === "function";
  }

  function cacheWishlistIcon() {
    if (wishlistIcon && wishlistIconMarkup) {
      return true;
    }

    const iconSource = document.querySelector(".iWishAddColl__icon") || document.querySelector(`${wishlistPageLinkSelector} svg`);

    if (!iconSource) {
      return false;
    }

    wishlistIcon = iconSource.cloneNode(true);
    wishlistIcon.classList.remove("header__nav-icon");
    wishlistIcon.classList.add("iWishAddColl__icon");
    wishlistIconMarkup = wishlistIcon.outerHTML;

    return true;
  }

  function configureCollectionIcons() {
    if (!window.iWishData || !cacheWishlistIcon()) {
      return false;
    }

    window.iWishData.iwish_add_txt_col = wishlistIconMarkup;
    window.iWishData.iwish_added_txt_col = wishlistIconMarkup;

    return true;
  }

  function syncButtonState(button) {
    button.setAttribute("aria-pressed", String(button.classList.contains("iwishAdded")));

    cacheWishlistIcon();

    if (wishlistIcon && !button.querySelector(".iWishAddColl__icon")) {
      button.replaceChildren(wishlistIcon.cloneNode(true));
    }
  }

  function syncWishlistPageLinks() {
    const wishlistCount = Array.from(document.querySelectorAll(wishlistCounterSelector)).reduce(
      (highestCount, counter) => {
        const count = Number.parseInt(counter.textContent.replace(/[^\d]/g, ""), 10);
        return Number.isNaN(count) ? highestCount : Math.max(highestCount, count);
      },
      0
    );

    document.querySelectorAll(wishlistPageLinkSelector).forEach((link) => {
      link.classList.toggle("wishlist-page-link--has-items", wishlistCount > 0);
      link.dataset.wishlistCount = String(wishlistCount);
      link.querySelector(".wishlist-page-link__dot")?.classList.toggle("is-visible", wishlistCount > 0);
    });
  }

  function refreshWishlistButtons() {
    if (!isIWishReady()) {
      return false;
    }

    const wishlistButtons = document.querySelectorAll(wishlistButtonSelector);
    const iconsConfigured = configureCollectionIcons();

    if (wishlistButtons.length === 0) {
      syncWishlistPageLinks();
      return true;
    }

    if (!iconsConfigured) {
      return false;
    }

    wishlistButtons.forEach((button) => {
      button.dataset.iwclick = "true";
    });
    window.iWish.checkIwishColl();
    document.querySelectorAll(wishlistButtonSelector).forEach(syncButtonState);
    syncWishlistPageLinks();

    return true;
  }

  function scheduleRefresh(attempt = 0) {
    window.clearTimeout(refreshTimer);

    if (refreshWishlistButtons() || attempt >= 40) {
      return;
    }

    refreshTimer = window.setTimeout(() => scheduleRefresh(attempt + 1), 250);
  }

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(wishlistButtonSelector);

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!isIWishReady()) {
        scheduleRefresh();
        return;
      }

      const variantId = button.dataset.variant;
      const productId = button.dataset.product;

      if (!variantId || !productId) {
        return;
      }

      if (!configureCollectionIcons()) {
        scheduleRefresh();
        return;
      }

      if (window.iwishAddProxy) {
        window.iwishAddProxy.click = "true";
      }

      if (window.iWish.isInWishlist(variantId)) {
        window.iWish.iwishRemove(variantId, productId);
        window.iWish.setIwishRemoved(button);

        if (window.changeDetect) {
          window.changeDetect.status = "removed";
        }
      } else {
        window.iWish.iwishAdd(variantId, productId, 1);
        window.iWish.setIwishAdded(button);

        if (window.changeDetect) {
          window.changeDetect.status = "added";
        }
      }

      syncButtonState(button);
      window.setTimeout(syncWishlistPageLinks, 0);
    },
    true
  );

  new MutationObserver((mutations) => {
    const hasNewWishlistButton = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(wishlistButtonSelector) || node.querySelector?.(wishlistButtonSelector))
      )
    );

    if (hasNewWishlistButton) {
      scheduleRefresh();
    }
  }).observe(document.getElementById("main") || document.body, { childList: true, subtree: true });

  new MutationObserver((mutations) => {
    const hasCounterUpdate = mutations.some((mutation) => {
      const mutationTarget =
        mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;

      return (
        mutationTarget?.matches?.(wishlistCounterSelector) ||
        mutationTarget?.closest?.(wishlistCounterSelector) ||
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.(wishlistCounterSelector) || node.querySelector?.(wishlistCounterSelector))
        )
      );
    });

    if (hasCounterUpdate) {
      syncWishlistPageLinks();
    }
  }).observe(document.body, { childList: true, characterData: true, subtree: true });

  const previousIWishInit = window.iWishinitFn;

  window.iWishinitFn = () => {
    if (typeof previousIWishInit === "function") {
      previousIWishInit();
    }

    scheduleRefresh();
  };

  document.addEventListener("shopify:section:load", () => scheduleRefresh());
  window.addEventListener("load", () => scheduleRefresh());
  syncWishlistPageLinks();
  scheduleRefresh();
})();
